import type { TimeRemaining, TimeRemainingProps } from '@disco/utils/time-utils'
import { calculateTimeRemaining } from '@disco/utils/time-utils'
import { useEffect, useState } from 'react'
import { useInterval } from 'hooks/use-interval'
export const useLiveCountdown = ({
  date,
  time,
  timeZone,
}: TimeRemainingProps): TimeRemaining => {
  const [timeRemaining, setTimeRemaining] = useState<TimeRemaining>(
    calculateTimeRemaining({
      date,
      time,
      timeZone,
    }),
  )
  useEffect(
    () =>
      setTimeRemaining(
        calculateTimeRemaining({
          date,
          time,
          timeZone,
        }),
      ),
    [date, time, timeZone],
  )
  useInterval(
    () =>
      setTimeRemaining(
        calculateTimeRemaining({
          date,
          time,
          timeZone,
        }),
      ),
    timeRemaining?.difference ?? 0 > 0 ? 1000 : null,
  )
  return timeRemaining
}
